<script>
import CompactElementUi from './Compact-Element-Ui.vue'
import GenerateTabItem from '../GenerateTabItem.vue'
import GenerateInline from './GenerateInline'
import GenerateColItem from './GenerateColItem'
import GenerateReport from './GenerateReport'
import GenerateCollapse from './GenerateCollapse'

export default {
	extends: GenerateTabItem,
	components: {
		GenerateFormItem: () => import('./GenerateFormItem.vue'),
		GenerateInline,
		GenerateColItem,
		GenerateReport,
		GenerateCollapse
	},
	mixins: [CompactElementUi]
}
</script>
